import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

import { PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'InputErrorMessages',
  props: {
  modelValue: {
    type: Array as PropType<string[] | undefined>,
    default: () => [],
  },
  errorClass: {
    type: [String, Array, Object],
    default: undefined,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.modelValue)
    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.modelValue, (error) => {
        return (_openBlock(), _createElementBlock("div", {
          key: error,
          class: _normalizeClass(["input-error", __props.errorClass])
        }, _toDisplayString(error), 3))
      }), 128))
    : _createCommentVNode("", true)
}
}

})